import React, { Component } from 'react';
import './style.scss';

class Dialog extends Component {
	constructor(props) {
		super(props);
		this.handleClick = this.handleClick.bind(this);
	}
	componentWillMount() {
		document.addEventListener('click', this.handleClick, false);
	}
	componentWillUnmount() {
		document.removeEventListener('click', this.handleClick, false);
	}
	handleClick(e) {
		const { outsideClose } = this.props;
		if (this.node.contains(e.target)) {
			return false;
		}
		outsideClose && this.props.closeDialog(e);
	}
	render() {
		const { children, height, styles, className } = this.props;
		const containerStyles = {
			height: 'auto',
			top: `calc(50% - ${height})`
		};
		return (
			<div className={`Dialog ${className}`} style={styles}>
				<div
					className="Dialog-container"
					ref={node => (this.node = node)}
					style={containerStyles}
				>
					{children}
				</div>
			</div>
		);
	}
}

Dialog.defaultProps = {
	outsideClose: true
};

class DialogCloseButton extends Component {
	render() {
		const { closeDialog, children } = this.props;
		return (
			<button className="Dialog-close" onClick={closeDialog}>
				{children || 'Close'}
			</button>
		);
	}
}
export { Dialog, DialogCloseButton };
